/**
 * 产品名单点（21d 改名：灵狐Chat → 05Chat）。
 *
 * 改名前这两个串在十几个文件里各写各的，漏一处就会出现新旧混用。
 * 非 TS 的那几处（index.html / manifest.webmanifest / deploy/webclip.config.json）
 * 无法 import，改名时要一起改——`e2e/pwa-meta.spec.ts` 钉死了它们与这里一致。
 */
export const BRAND_NAME = '05Chat';

/** 账号号码的称呼（旧版叫「灵狐号」，随产品名走） */
export const ACCOUNT_NO_LABEL = '05号';
